const API_BASE_URL = 'https://bvs.worldgurujiedu.org';

export default API_BASE_URL;
